<!-- ✅inizio modifica MAT-->
  
// Aggiornamento metafield capacità per varianti
(function() {
  // Funzione per aggiornare il metafield della capacità
  function updateCapacityMetafield() {
    const capacityElement = document.querySelector('[data-variant-capacity]');
    const metafieldsContainer = document.querySelector('[data-variant-metafields]');
    if (!capacityElement || !metafieldsContainer) return;
    
    // Ottieni l'ID della variante selezionata
    let variantId = '';
    const variantSelector = document.querySelector('select[name="id"], input[name="id"]:checked');
    if (variantSelector) {
      variantId = variantSelector.value;
    }
    
    // Se abbiamo trovato l'ID della variante
    if (variantId) {
      // Cerca l'attributo data per questa variante
      const capacityAttr = metafieldsContainer.getAttribute(`data-variant-${variantId}-capacity`);
      
      if (capacityAttr && capacityAttr !== '') {
        capacityElement.textContent = capacityAttr + ' L';
      } else {
        capacityElement.textContent = 'N/D';
      }
    }
  }
  
  // Funzione per configurare gli event listener
  function setupEventListeners() {
    // Esegui all'avvio
    updateCapacityMetafield();
    
    // Monitora tutti i possibili eventi di cambio variante
    
    // 1. Evento standard di Shopify
    document.addEventListener('variant:change', updateCapacityMetafield);
    
    // 2. Cambiamenti nei selettori di variante
    const variantSelectors = document.querySelectorAll('.single-option-selector, [data-single-option-selector], select[name="id"], input[name="id"]');
    variantSelectors.forEach(selector => {
      selector.addEventListener('change', function() {
        setTimeout(updateCapacityMetafield, 100);
      });
    });
    
    // 3. Monitora i clic sui pulsanti delle varianti
    const variantButtons = document.querySelectorAll('.variant-input label, .swatch-element label');
    variantButtons.forEach(button => {
      button.addEventListener('click', function() {
        setTimeout(updateCapacityMetafield, 100);
      });
    });
    
    // 4. Polling aggressivo per i temi che aggiornano il DOM in modo asincrono
    setInterval(updateCapacityMetafield, 500);
  }
  
  // Configura quando il DOM è pronto
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupEventListeners);
  } else {
    setupEventListeners();
  }
})();



<!-- fine modifica MAT✅-->